import { useTranslation } from "react-i18next"

const ContactUs = () => {
  const { t } = useTranslation(['contactUs']);
  return (
    <div className="!bg-white px-6 pb-12 sm:px-16 h-[45vh] pt-10 text-2xl text-gray-400">{t('contactUsComingSoon')} ...</div>
  )
}

export default ContactUs